import { I18N } from 'aurelia-i18n';
import { MerchantConsumerPortalFeeSettings } from '../../merchant-consumer-portal-fee-settings';
import { PaymentMethodType } from '../../../services/hpf-transaction-service';
import { InstallmentFrequency } from '../../installment-frequency';

export class ApplePayUtil {
	static getRecurringPaymentDateUnit(selectedFrequency: InstallmentFrequency): ApplePayJSV14.ApplePayRecurringPaymentDateUnit {
		switch (selectedFrequency) {
			case InstallmentFrequency.Monthly:
			case InstallmentFrequency.FifteenthOfEachMonth:
			case InstallmentFrequency.EndOfMonth:
			case InstallmentFrequency.Every2Months:
				return 'month';
			default:
				return 'day';
		}
	}

	static getRecurringPaymentIntervalCount(selectedFrequency: InstallmentFrequency): number {
		switch (selectedFrequency) {
			// months
			case InstallmentFrequency.Monthly:
			case InstallmentFrequency.FifteenthOfEachMonth:
			case InstallmentFrequency.EndOfMonth:
				return 1;
			case InstallmentFrequency.Every2Months:
				return 2;
			// days
			case InstallmentFrequency.Weekly:
				return 7;
			case InstallmentFrequency.Every2Weeks:
				return 14;
			case InstallmentFrequency.Every28Days:
				return 28;
		}
	}

	static getBillingAgreement(merchantConsumerPortalFeeSettings: MerchantConsumerPortalFeeSettings, i18n: I18N): string {
		if (!merchantConsumerPortalFeeSettings.feesEnabled || !merchantConsumerPortalFeeSettings.allowFeesOnPaymentPlans) {
			return '';
		}

		return merchantConsumerPortalFeeSettings.allowServiceFeesOnEveryTransaction
			? i18n.i18next.t('serviceFeeOnEveryTransaction', 'A service fee will be charged on every transaction')
			: i18n.i18next.t('serviceFeeOnFirstTransaction', 'A service fee will be charged on the first transaction');
	}

	static getPaymentMethodType(paymentMethod: ApplePayJS.ApplePayPaymentMethod): PaymentMethodType {
		// map to PaymentMethodType
		let paymentMethodType: PaymentMethodType = PaymentMethodType.NotSet;
		switch (paymentMethod.type.toLowerCase()) {
			case 'credit':
				paymentMethodType = PaymentMethodType.Credit;
				break;
			case 'debit':
			case 'prepaid':
				paymentMethodType = PaymentMethodType.Debit;
				break;
			default:
				paymentMethodType = PaymentMethodType.NotSet;
		}

		return paymentMethodType;
	}

	static completeSession(submitApplePayEvent: CustomEvent, isSuccessful: boolean): void {
		const applePayResult = isSuccessful ? ApplePaySession.STATUS_SUCCESS : ApplePaySession.STATUS_FAILURE;
		submitApplePayEvent.detail.digitalWalletSession?.completePayment(applePayResult);
		if (!isSuccessful) {
			// close the session. we display error on receipt page
			submitApplePayEvent.detail.digitalWalletSession?.abort();
		}
	}
}
